import type { UserRole } from '@lmc/ts-common'

export enum CapabilityKey {
  SafeguardingOversight = 'safeguardingOversight',
  InsightsHubAccess = 'insightsHubAccess',
  TeamManagement = 'teamManagement',
  ServiceUserManagement = 'serviceUserManagement',
  IncidentManagement = 'incidentManagement',
  DownloadCentreAccess = 'downloadCentreAccess',
  MedicationManagement = 'medicationManagement'
}

export type WizardRole = UserRole

// CM-3388: scopes the Add-member wizard's role roster + create payload.
//   single-site     → existing TeamListV2 behaviour (no home/homeGroup)
//   specific-sites  → site roster + required Site multi-select → home: homes[0]
//   group-dashboard → group roles only, no Site field → homeGroup from viewer
export type RoleRosterScope =
  | 'single-site'
  | 'specific-sites'
  | 'group-dashboard'

export type ToggleConfig = {
  key: CapabilityKey
  labelKey: string // UPPER_SNAKE_CASE key from teamConstants — resolved via t() in Step 3 component
  bullets: { variant: 'tick' | 'cross'; copyKey: string }[]
  defaultValue: boolean
  permissionId?: string // omitted for medicationManagement (boolean field)
}
